import type { BulkCreateRests } from '@libs/data-access/entities'
import { formatToWeekISO } from '@spa/services/utils'

import type { TableRevaluatedData } from './RestFormSection/utils/revaluation.types'
import { type RestFormData } from './hooks/useRestRHF'

const CUSTOM = 'custom'

type GetSubmitDataUpdateParams = {
  currentUserId: number | undefined
  finalContractsIds: string[]
  formData: RestFormData
  restDurationOption: string
  revaluatedInputData: object
  revaluatedData: TableRevaluatedData[]
  watch: Function
}

type GetSubmitDataBulkParams = {
  selectedMemberships: number[]
  formData: RestFormData
  watch: Function
}

export const getSubmitDataForSingleRest = ({
  currentUserId,
  finalContractsIds,
  formData,
  restDurationOption,
  revaluatedInputData,
  revaluatedData,
  watch
}: GetSubmitDataUpdateParams) => {
  // if multi contracts we ignore the revalo data
  const isMulti = finalContractsIds.length > 1

  return finalContractsIds.map(contractId => {
    const revaluationDataToSubmit = revaluatedData.map(
      ({
        week,
        is_complete_week: isCompleteWeek,
        contract_time: contractTime
      }) => {
        const weekIso = formatToWeekISO(week)

        const weekValue =
          (isCompleteWeek && contractTime) ||
          (revaluatedInputData[weekIso] &&
            revaluatedInputData[weekIso].value) ||
          0

        return {
          [weekIso]: Number(weekValue),
          incomplete_week: !isCompleteWeek
        }
      }
    )

    const revaloData =
      restDurationOption === CUSTOM && !isMulti
        ? {
            custom_value: revaluationDataToSubmit,
            rest_value_updated_at: new Date(),
            rest_value_updated_by_id: currentUserId
          }
        : { custom_value: [] }

    const newData = {
      user_contract_id: contractId,
      rest_type: formData.rest_type.value,
      starts_at: formData.momentStart.format(),
      ends_at: formData.momentEnd.format(),
      note: watch('note'),
      accident_date: formData.accident_date,
      shift_conflict_strategy: formData.shift_conflict_strategy,
      ...revaloData
    }

    return newData
  })
}

export const getSubmitDataBulk = ({
  selectedMemberships,
  formData,
  watch
}: GetSubmitDataBulkParams): BulkCreateRests => {
  return {
    membership_ids: selectedMemberships,
    rest_attributes: {
      type: formData.rest_type.value,
      starts_at: formData.momentStart.format(),
      ends_at: formData.momentEnd.format(),
      note: watch('note')
    },
    shift_conflict_strategy: formData.shift_conflict_strategy
  }
}
